export default __webpack_public_path__ + "static/media/desk_preland_3.52e66902.jpg";